import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import styled from 'styled-components'
import { JazeelContext } from '../../../utils/JazeelContext'
import Card from 'react-bootstrap/Card'
import PropTypes from 'prop-types'
const InformationContainer = styled(Col)`
  text-align: center;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 6px 26px 0 rgba(0, 0, 0, 0.08);
  @media screen and (max-width: 768px) {
    background-color: ${props => props.color};
    box-shadow: 0 0 0 0;
  }
`
const ViewLink = styled(Link)`
  color: #fff;
  background: rgb(23, 191, 207);
  background: linear-gradient(
    90deg,
    rgba(23, 191, 207, 1) 0%,
    rgba(152, 222, 99, 1) 100%
  );
  border-color: rgb(23, 191, 207);
  :hover {
    color: black;
    border-color: rgb(23, 191, 207);
  }
`
const InformationCard = styled(Card)`
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 2px 26px 0 rgba(0, 0, 0, 0.08);
  border: 0;
  width: 46.7vw;
`
const CardBody = styled(Card.Body)`
  padding: 0.5em 2em;
`
const Number = styled.h1`
  color: #212529;

  font-size: 1.563em;
  font-weight: bold;
  line-height: 1.875em;
  text-align: center;
  margin-bottom: 0;
`
const Title = styled.p`
  color: #212529;

  font-size: 0.7em;
  line-height: 0.813em;
  text-align: center;
`
export default function InformationSection({ color }) {
  const { userData, isMobile } = useContext(JazeelContext)
  return (
    <Row className="no-gutters mt-4">
      <InformationContainer md={12} color={color}>
        {isMobile ? (
          <Row className="p-3">
            <Col md={10} className="pl-0">
              <Row>
                <Col md={6} xs={6}>
                  <InformationCard>
                    <CardBody>
                      {/*<Number>{userData && userData.referral_count}</Number>*/}
                      <Number>8</Number>
                      <Title>Links Clicks</Title>
                    </CardBody>
                  </InformationCard>
                </Col>
                <Col md={6} xs={6}>
                  <InformationCard>
                    <CardBody>
                      <Number>
                        6{/*{userData && userData.friend_purchase_count}*/}
                      </Number>
                      <Title>Purchased tickets</Title>
                    </CardBody>
                  </InformationCard>
                </Col>
                <Col md={6} xs={6} className="mt-2">
                  <InformationCard>
                    <CardBody>
                      {/*<Number>{userData && userData.social_media_posts}</Number>*/}
                      <Number>9</Number>
                      <Title>Social media posts</Title>
                    </CardBody>
                  </InformationCard>
                </Col>
                <Col md={6} xs={6} className="mt-2">
                  <InformationCard>
                    <CardBody>
                      {/*<Number>{userData && userData.email_invitations}</Number>*/}
                      <Number>2</Number>
                      <Title>Email invitations</Title>
                    </CardBody>
                  </InformationCard>
                </Col>
              </Row>
            </Col>
            {/*<Col*/}
            {/*  md={2}*/}
            {/*  className="text-center align-self-center justify-content-center"*/}
            {/*>*/}
            {/*  <ViewLink*/}
            {/*    to="dashboard/transaction-history"*/}
            {/*    className="btn btn-sm mt-2 btn-block"*/}
            {/*  >*/}
            {/*    View Details*/}
            {/*  </ViewLink>*/}
            {/*</Col>*/}
          </Row>
        ) : (
          <Row className="p-3">
            <Col md={12} lg={10}>
              <Row>
                <Col md={3} className="border-right">
                  {/*<Number>{userData && userData.referral_count}</Number>*/}
                  <Title>Link Clicks</Title>
                </Col>
                <Col md={3} className="border-right">
                  {/*<Number>{userData && userData.friend_purchase_count}</Number>*/}
                  <Title>Friends&apos; Purchase</Title>
                </Col>
                <Col md={3} className="border-right">
                  {/*<Number>{userData && userData.social_media_posts}</Number>*/}
                  <Title>Social Media Posts</Title>
                </Col>
                <Col md={3}>
                  {/*<Number>{userData && userData.email_invitations}</Number>*/}
                  <Title>Email Invitations</Title>
                </Col>
              </Row>
            </Col>
            <Col
              lg={2}
              className="text-center align-self-center justify-content-center"
            >
              <ViewLink
                to="dashboard/transaction-history"
                className="btn btn-sm mt-2"
              >
                View Details
              </ViewLink>
            </Col>
          </Row>
        )}
      </InformationContainer>
    </Row>
  )
}
InformationSection.propTypes = {
  color: PropTypes.string,
}
InformationSection.defaultProps = {
  color: '#f9f9f9',
}
